import * as React from "react";
import { navigate } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";
import Layout from "../components/Layout/Layout";
import T from "../components/T/T";
import { useEffect, useState } from "react";

export default function Cookies() {
  const [accepted, setAccepted] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      if (localStorage.getItem("cookieAccepted")) {
        setAccepted(true)
      }
    }
  }, []);


  const accept = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem("cookieAccepted", "1");
    }

    setAccepted(true)
  };

  const reject = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("cookieAccepted");
    }

    setAccepted(false)
  };

  const cookiesButton = !accepted ?
    (
      <button
        className="uk-button uk-width-1-1 uk-button-secondary uk-margin hideModal"
        onClick={accept}>
        <T>accept-cookie</T>
      </button>
    ) : (
      <button
        className="uk-button uk-width-1-1 uk-button-secondary uk-margin hideModal"
        onClick={reject}>
        <T>reject-cookie</T>
      </button>
    );

  const translatedText = intl.formatMessage({ id: 'cookie-policy-text' });

  return (
    <>
      <title><T>cookie-policy-title</T></title>

      <Layout hideFooter={false} hideCookies={true}>
        <div className="uk-container">
          <div className="back-action">
            <button className="back-button" onClick={() => navigate(-2)}>
              <span><T>back-button</T></span>
            </button>
          </div>

          <div className="terms-body-holder">
            <h1><T>cookie-policy-title</T></h1>

            <div className="terms-content-holder" dangerouslySetInnerHTML={{ __html: translatedText }}></div>

            {cookiesButton}
          </div>
        </div>
    </Layout>
    </>
  );
}
